import axiosRequest from '../axios-config';
import { getCookie } from 'cookies-next';

export const loginAsCustomer = async ({ customerId }) => {
  const config = {
    method: 'POST',
    url: `/customer/loginAsCustomer`,
    data: JSON.stringify({ customerId }),
  };
  try {
    const res = await axiosRequest(config);
    return res.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const updateAdminOrder = async ({ orderId }) => {
  const adminId = getCookie('adminId');
  if (!adminId) return;

  const config = {
    method: 'POST',
    url: `/customer/updateAdminOrder`,
    data: JSON.stringify({
      orderId,
      adminId,
    }),
  };
  try {
    const res = await axiosRequest(config);
    return res.data;
  } catch (err) {
    console.error('Error updating admin order:', err);
    return err;
  }
};
